export const LocationPriority = {
    ONE: '1',
    TWO: '2',
    ALL: 'ALL',
};
